import React from 'react';
import { DEFAULT_IAM_DETAILS } from '../constants/ApiEndpoints';
import { makeGetRequest } from '../helpers/biztechAxiosRequest';
import loadingGif from '../assets/loading.gif';
import blueSearchIcon from '../assets/bluesearch.png';
import { withRouter } from '../containers/WithRouter';
import OrganizationCard from './OrganizationCard';

function SearchBox(props: {
  handleKeyPress: (event: { key: string }) => void;
  organizationId: string;
  handleChange: (event: { target: { name: string; value: string } }) => void;
  getCustomerIamDetails: (organizationId: string) => void;
}) {
  return (
    <div className="SearchContainer">
      <div className="SearchBarArea">
        <div className="SearchBar">
          <input
            className="SearchBox"
            placeholder="Search Id ..."
            onKeyPress={props.handleKeyPress}
            value={props.organizationId}
            onChange={props.handleChange}
            type="text"
            name="organizationId"
            required
          />
          <img
            src={blueSearchIcon}
            alt="Search Icon"
            className="SearchButton"
            onClick={props.getCustomerIamDetails as any}
          />
        </div>
      </div>
    </div>
  );
}

class IamDetailsComponent extends React.Component<{
  router: any;
}> {
  state = {
    organizationId: '',
    iamDetails: [],
    loading: false,
    errorMessage: '',
    showInfo: false
  };

  handleUrlParameter = () => {
    const organizationId = this.props?.router?.params?.id;
    if (organizationId) {
      this.setState({ organizationId }, () => {
        // This callback will run after state is updated
        this.getIamDetails(organizationId);
      });
    }
  };

  getIamDetails = (organizationId: string) => {
    const env = this.props?.router?.location?.pathname?.includes('Sandbox')
      ? 'organizationSandbox'
      : 'organization';
    this.setState({
      env: env
    });
    const iamDetailsURL = `${DEFAULT_IAM_DETAILS}?organizationId=${organizationId}&subtype=${env}`;
    makeGetRequest(iamDetailsURL)
      .then((result: any) => {
        this.setState({
          iamDetails: result.data
        });
        this.setState({ loading: false });
        this.setState({ errorMessage: '' });
      })
      .catch(error => {
        this.setState({ errorMessage: 'Sorry, something went wrong !' });
        this.setState({ loading: false });
        this.setState({
          iamDetails: []
        });
      });
  };

  componentDidMount() {
    this.handleUrlParameter();
  }

  handleKeyPress = (event: { key: string }) => {
    const env = this.props?.router?.location?.pathname?.includes('Sandbox')
      ? 'organizationSandbox'
      : 'organization';
    if (event.key === 'Enter') {
      window.history.replaceState(
        null,
        '',
        `/#/${env}/${this.state.organizationId}`
      );
      this.getIamDetails(this.state.organizationId);
    }
  };

  handleChange = (event: any) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    if (this.state.loading) {
      return (
        <div>
          {' '}
          <br />
          <br /> <br /> <img src={loadingGif} alt="Please wait" />{' '}
          <h1>processing ...</h1>{' '}
        </div>
      );
    }

    if (!this.state.loading) {
      return (
        <>
          <SearchBox
            handleKeyPress={this.handleKeyPress}
            organizationId={this.state.organizationId}
            handleChange={this.handleChange}
            getCustomerIamDetails={this.getIamDetails}
          />

          {this.state.organizationId !== '' && this.state.errorMessage && (
            <div>
              <br />
              <h1>
                {`IAM Details not found for ${
                  this.props?.router?.location?.pathname?.includes('Sandbox')
                    ? 'organizationSandbox'
                    : 'organization'
                } Id: `}
                {this.state.organizationId}
              </h1>{' '}
            </div>
          )}

          {this.state.organizationId === '' && (
            <div>
              <h3>
                Please enter organization Id to search
                {this.state.organizationId}
              </h3>
            </div>
          )}
          {this.state.iamDetails.length != 0 && (
            <OrganizationCard
              data={{
                ...this.state.iamDetails,
                env: this.props?.router?.location?.pathname?.includes('Sandbox')
                  ? 'organizationSandbox'
                  : 'organization'
              }}
            />
          )}
        </>
      );
    }
  }
}

export default withRouter(IamDetailsComponent);
